import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
//
import { AuthRoutingModule } from './auth-routing.module'
import { NbAuthModule } from '@nebular/auth'
import { LoginComponent } from './login/login.component'
import {
    NbAlertModule,
    NbButtonModule,
    NbCardModule,
    NbCheckboxModule,
    NbDatepickerModule,
    NbIconModule,
    NbInputModule,
    NbLayoutModule,
    NbRadioModule,
    NbStepperModule,
} from '@nebular/theme'
import { OauthCallbackComponent } from './oauth-callback/oauth-callback.component'
import { FacebookOauthCallbackComponent } from './oauth-callback/facebook/facebook-oauth-callback.component'
import { GoogleOauthCallbackComponent } from './oauth-callback/google/google-oauth-callback.component'
import { AppleOauthCallbackComponent } from './oauth-callback/apple/apple-oauth-callback.component'

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        NbAlertModule,
        NbInputModule,
        NbButtonModule,
        NbCheckboxModule,
        AuthRoutingModule,
        NbAuthModule,
        NbIconModule,
        NbStepperModule,
        NbLayoutModule,
        NbCardModule,
        ReactiveFormsModule,
        NbRadioModule,
        NbDatepickerModule,
    ],
    providers: [],
    declarations: [
        LoginComponent,
        OauthCallbackComponent,
        FacebookOauthCallbackComponent,
        GoogleOauthCallbackComponent,
        AppleOauthCallbackComponent,
    ],
})
export class AuthModule {}
